<template>
  <div
    class="d-flex p-4"
    style="
      flex-wrap: wrap;
      align-items: center;
      gap: 16px;
      flex-direction: column;
      background-color: #00000005;
    "
  >
    <FlugstreckenVergleichHinRueck
      style="flex-grow: 1"
      :flugstrecke="hinflug"
      :teilnehmer="teilnehmer"
      art="Hinflug"
      :vorverlaengerungen="vorverlaengerungen"
      :teilnehmerVerlaengerungen="teilnehmerVorverlaengerungen"
    />
    <FlugstreckenVergleichInlandsfluege
      v-if="inlandsfluege && inlandsfluege.length > 0"
      style="flex-grow: 1"
      :flugstrecken="inlandsfluege"
    />
    <FlugstreckenVergleichHinRueck
      style="flex-grow: 1"
      :flugstrecke="rueckflug"
      :teilnehmer="teilnehmer"
      art="Rückflug"
      :verlaengerungen="verlaengerungen"
      :teilnehmerVerlaengerungen="teilnehmerVerlaengerungen"
    />
  </div>
</template>
<script>
import FlugstreckenVergleichHinRueck from './flugstrecken-vergleich-hinRueck.vue';
import FlugstreckenVergleichInlandsfluege from './flugstrecken-vergleich-inlandsfluege.vue';
import { compareAsc } from 'date-fns';

export default {
  components: { FlugstreckenVergleichHinRueck, FlugstreckenVergleichInlandsfluege },
  props: { teilnehmer: { type: Object } },
  computed: {
    verlaengerungen() {
      return this.teilnehmer.verlaengerungen.filter(
        v => v.istVorverlaengerung == false && v.deletedAt == null
      );
    },
    vorverlaengerungen() {
      return this.teilnehmer.verlaengerungen.filter(
        v => v.istVorverlaengerung == true && v.deletedAt == null
      );
    },
    teilnehmerVorverlaengerungen() {
      return this.teilnehmer.teilnehmerVerlaengerungen.filter(
        v => v.istVorverlaengerung == true && v.deletedAt == null
      );
    },
    teilnehmerVerlaengerungen() {
      return this.teilnehmer.teilnehmerVerlaengerungen.filter(
        v => v.istVorverlaengerung == false && v.deletedAt == null
      );
    },
    hinflug() {
      return this.teilnehmer.teilnehmerReiseterminFlugstrecken.find(
        teilnehmerReiseterminFlugstrecke =>
          teilnehmerReiseterminFlugstrecke.reiseterminFlugstrecke.flugstreckeTyp === 'MainHin'
      );
    },
    rueckflug() {
      return this.teilnehmer.teilnehmerReiseterminFlugstrecken.find(
        teilnehmerReiseterminFlugstrecke =>
          teilnehmerReiseterminFlugstrecke.reiseterminFlugstrecke.flugstreckeTyp === 'MainRueck'
      );
    },
    inlandsfluege() {
      return this.teilnehmer.teilnehmerReiseterminFlugstrecken
        .filter(
          teilnehmerReiseterminFlugstrecken =>
            teilnehmerReiseterminFlugstrecken.reiseterminFlugstrecke.flugstreckeTyp === 'Inlandsflug'
        )
        .sort((a, b) =>
          compareAsc(
            new Date(a.reiseterminFlugstrecke.abflugdatum),
            new Date(b.reiseterminFlugstrecke.abflugdatum)
          )
        );
    },
  },
};
</script>
